(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/picasso/assets/javascripts/picasso-setup.js') >= 0) return;  svs.modules.push('/components/numbergames/picasso/assets/javascripts/picasso-setup.js');

'use strict';

const imageTypes = {
  campaignMobile: 'campaign-mobile',
  campaignDesktop: 'campaign-desktop'
};
const picassoInstance = {
  [imageTypes.campaignMobile]: 'campaign',
  [imageTypes.campaignDesktop]: 'campaign'
};
const imagesFitWrapper = {
  [imageTypes.campaignMobile]: true,
  [imageTypes.campaignDesktop]: true
};
const imagesSizes = {
  [imageTypes.campaignMobile]: '100vw',
  [imageTypes.campaignDesktop]: '100vw'
};
const imagesLazyLoading = {
  [imageTypes.campaignMobile]: false,
  [imageTypes.campaignDesktop]: false
};
const preferredWidths = {
  [imageTypes.campaignMobile]: [320, 480],
  [imageTypes.campaignDesktop]: [800, 1280, 1920]
};
const imagesDescription = {
  [imageTypes.campaignMobile]: {
    altText: 'kampanj bild',
    title: 'Kampanj bild'
  },
  [imageTypes.campaignDesktop]: {
    altText: 'kampanj bild',
    title: 'Kampanj bild'
  }
};
const availableFormats = [{
  mimetype: 'image/webp',
  extension: 'webp'
}, {
  mimetype: 'image/jpeg',
  extension: 'jpg'
}];
const getImagesExtensions = imageType => {
  switch (imageType) {
    case imageTypes.campaignMobile:
    case imageTypes.campaignDesktop:
      return ['jpg', 'png'];
    default:
      return ['webp', 'png'];
  }
};
const getAspectRatio = imageType => {
  switch (imageType) {
    case imageTypes.campaignMobile:
      return {
        width: '620',
        height: '500'
      };
    case imageTypes.campaignDesktop:
      return {
        width: '1920',
        height: '500'
      };
    default:
      return '';
  }
};
const getMultiBreakPoint = imageType => {
  switch (imageType) {
    case imageTypes.campaignMobile:
      return '479px';
    case imageTypes.campaignDesktop:
      return '480px';
    default:
      return '768px';
  }
};
const exported = {
  imageTypes,
  picassoInstance,
  imagesFitWrapper,
  imagesSizes,
  imagesLazyLoading,
  preferredWidths,
  imagesDescription,
  availableFormats,
  getImagesExtensions,
  getAspectRatio,
  getMultiBreakPoint
};
if (svs.isServer) {
  module.exports = exported;
} else {
  svs.numbergames.picasso.setup = exported;
}

 })(window);